import {BioentityAliasInfo} from 'constants/RegistryConstants';
import * as MediocreConstants from 'notebook/mediocre/MediocreConstants';
import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';
import {SearchResult, SearchResultItemType} from 'ui-library/inputs/ItemOptionContent';

export interface LinkedItem {
  id?: string;
  name?: string;
  bioentityAliasInfos?: Array<BioentityAliasInfo>;
  filename?: string;
  fileId?: string;
  iconId?: BenchlingIconName;
  barcode?: string;
  editURL?: string;
  editUrl?: string;
  url?: string;
  folder?: {
    source?: object;
  };
  tagSchema?: object | null;
  source?: object; // for StageEntries and Workflows
}

// This type essentially represents a search result, which is why we extend SearchResult, even though it is
// currently any. We should replace this with SearchResult when it becomes more concrete.
export interface AttachDropdownItem extends SearchResult {
  name: string;
  item_id: string;
  creator?: string;
  type?: SearchResultItemType;
  handle?: string;
  item: LinkedItem;
  extra?: {
    ancestralStorables?: Array<object>;
    containedItems?: Array<object>;
  };
  createdAt?: string;
  fileName?: string;
  internalLink?: MediocreConstants.InternalLink;
  noIcon?: boolean;
  isSelected?: boolean;
}

export enum OptionHeight {
  MEDIUM = 'medium',
  LARGE = 'large',
  XLARGE = 'xl',
}
